document.addEventListener('DOMContentLoaded', function () {
  var revealEls = document.querySelectorAll('.mosdela-reveal');
  if ('IntersectionObserver' in window && revealEls.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-visible'); });
  }

  var hero = document.querySelector('[data-mosdela-hero]');
  var header = document.querySelector('header.shopify-section, #shopify-section-header, .header-wrapper');
  if (hero && header) {
    var applyState = function () {
      if (window.scrollY > 60) {
        header.classList.add('mosdela-header--solid');
        header.classList.remove('mosdela-header--transparent');
      } else {
        header.classList.add('mosdela-header--transparent');
        header.classList.remove('mosdela-header--solid');
      }
    };
    document.addEventListener('scroll', applyState, { passive: true });
    applyState();
  }
});
